import Column from "@/Components/Grid/Column";
import Row from "@/Components/Grid/Row";
import GraphSrcSetImage from "../GraphSrcSetImage/GraphSrcSetImage";
import FrontText from "../../FrontText";
import sanitizeHTML from "@/Helpers/sanitizeHTML";
import WebpImage from "../WebpImage";

const AcfImageWithContent = ({ description, blockSpacing = 'xl:my-c120 lg:my-20 md:my-15 my-10', heading, title, imagePosition, image, graphql = true, sourcesWebp = '', fallbackWebp = '' }) => {
    return (
        <Column className={`${blockSpacing}`}>
            <Row className={`${imagePosition ? 'md:flex-row-reverse' : ''} gap-y-10 justify-between md:flex-nowrap xl:gap-c130 lg:gap-20 md:gap-10 items-center`}>
                <Column xl={5} lg={5} md={6}>
                    {graphql ?
                        <GraphSrcSetImage alt={title} srcSet={image.srcSet} className="w-full" />
                        :
                        <WebpImage alt={title} sources={sourcesWebp} fallback={fallbackWebp} className="w-full" lazy/>
                    }
                </Column>
                <Column xl={7} lg={7} md={6}>
                    <FrontText textSize='16/20' className="text-heading-blue font-semibold mb-5">
                        {sanitizeHTML(title)}
                    </FrontText>
                    <FrontText textSize='32/39-m-28/36' className="text-heading-blue font-semibold">
                        {sanitizeHTML(heading)}
                    </FrontText>
                    <FrontText textSize='16/20' className="text-standard-black md:mt-10 mt-5" spacings>
                        {sanitizeHTML(description)}
                    </FrontText>
                </Column>
            </Row>
        </Column>
    )
}

export default AcfImageWithContent;